import {shapeTypeConst} from '../../../conf';

/**
 * 拓扑插件-边（连线）样式参数配置
 */



/**
 * 拓扑插件-状态样式-边（连线）默认样式参数配置
 * @type attrs 边（连线）默认样式参数
 */
export const defaultStyle = {
  type: shapeTypeConst.quadratic,
  // 边样式配置
  style: {
    // 边透明度
    opacity: 0.8,
    // 边描边颜色
    stroke: 'grey',
    lineWidth: 1
  },
  // 边上的标签文本配置
  labelCfg: {
    // 边上的标签文本根据边的方向旋转
    autoRotate: true
  }
};


/**
 * 拓扑插件-状态样式-边（连线）状态样式
 * @type attrs 节点默认状态样式
 */
export const defaultStyles = {
  lineWidth: 1,
  stroke: 'grey'
};


/**
 * 拓扑插件-状态样式-鼠标移入或悬停边（连线）的样式集合
 * @type attrs 鼠标移入或悬停边（连线）的样式
 */
export const activeStyles = {
  lineWidth: 3,
  stroke: '#5f95ff'
};


/**
 * 拓扑插件-状态样式-边（连线）不可用/不可选样式
 * @type attrs 不可用/不可选样式
 */
export const disableStyles = {
  lineWidth: 1.5,
  stroke: '#a7a8aa'
};


/**
 * 拓扑插件-状态样式-鼠标点击边（连线）的样式集合
 * @type attrs 边（连线）被点击的样式
 */
export const selectedStyles = {
  lineWidth: 3,
  stroke: '#5f95ff'
};


/**
 * 拓扑插件-状态样式-健康边（连线）的样式集合
 * @type attrs 健康边（连线）的样式
 */
export const healthyStyles = {
  lineWidth: 1.5,
  stroke: '#22b255'
};


/**
 * 拓扑插件-状态样式-告警时样式集合
 * @type attrs 告警时样式
 */
export const warningStyles = {
  lineWidth: 1.5,
  stroke: '#fa9e0f'
};


/**
 * 拓扑插件-状态样式-设备故障时样式集合
 * @type attrs 设备故障时样式
 */
export const errorStyles = {
  lineWidth: 1.5,
  stroke: '#d40d0b'
};


/**
 * 拓扑插件-状态样式-边（连线）不同状态下的样式集合
 * @type attrs 边（连线）各状态下样式
 */
export const stateStyles = {
  // 默认状态
  defaultState: defaultStyles,
  // 不可用/不可选
  disable: disableStyles,
  // 唤起，鼠标经过/悬停
  active: activeStyles,
  // 选择，鼠标单击/双击/框选/拖拽/吸附
  selected: selectedStyles,
  // 健康的
  healthy: healthyStyles,
  // 告警时
  warning: warningStyles,
  // 错误时
  error: errorStyles,

  // 强化，点亮对比既定节点时，做突出展示
  highlight: null,
  // 弱化，点亮对比别的节点时，做弱化展示
  inactive: null
};



/**
 * 拓扑插件-状态样式-获取节点默认参数配置
 * @param options 扩展参数
 * @returns attrs 节点默认参数配置
 */
export function getGraphStyle(options) {
  const attrs = {...this.defaultStyle};
  if (options) {
    Object.assign(attrs, options);
  }
  return attrs;
}
